import { Injectable } from '@angular/core';
import { CalendarEventKind } from '@sb/library/base';
import { CalendarBirthdayEventDisplayItem, CalendarBookingDisplayItem, CalendarColorMode, CalendarEventDisplayItem, CalendarRepertoirePerformanceDisplayItem, EventColorEnum } from '@sb/library/data-models';

@Injectable({
    providedIn: 'root'
})
export class CalendarEventManager {

    private _defaultColor: EventColorEnum = EventColorEnum.White;
    private _hoveredEventID: { [key: string]: string } = {};

    GetEventColor(mode: CalendarColorMode, event: CalendarEventDisplayItem | CalendarBirthdayEventDisplayItem | CalendarRepertoirePerformanceDisplayItem | CalendarBookingDisplayItem, kind: CalendarEventKind): EventColorEnum {
        let eventColor = this._defaultColor;
        switch (mode) {
            case CalendarColorMode.EventCategory:
                if (kind === CalendarEventKind.Calendar || kind === CalendarEventKind.BookingSlot) {
                    const data = event as CalendarEventDisplayItem || event as CalendarBookingDisplayItem;
                    if (data.EventCategory) {
                        eventColor = data.EventCategory.Color;
                    }
                }
                break;
            case CalendarColorMode.Location:
                if (kind === CalendarEventKind.Calendar || kind === CalendarEventKind.BookingSlot) {
                    const data = event as CalendarEventDisplayItem || event as CalendarBookingDisplayItem;
                    if (data.EventLocation) {
                        eventColor = data.EventLocation.Color;
                    }
                }
                break;
            case CalendarColorMode.Teacher:
                if (kind === CalendarEventKind.Calendar || kind === CalendarEventKind.BookingSlot) {
                    const data = event as CalendarEventDisplayItem || event as CalendarBookingDisplayItem;
                    if (data.Teacher) {
                        eventColor = data.Teacher.Color;
                    }
                }
                break;
        }

        if (kind === CalendarEventKind.RepertoirePerformance || kind === CalendarEventKind.Birthday) {
            const data = event as CalendarRepertoirePerformanceDisplayItem | CalendarBirthdayEventDisplayItem;
            eventColor = data.Color;
        }
        return eventColor;
    }

    get hoveredEventID(): { [key: string]: string } {
        return this._hoveredEventID;
    }

    set hoveredEventID(value: { [key: string]: string }) {
        this._hoveredEventID = value;
    }
}
